import { RootState } from 'src/types';

export const toggleEditQuoteSelector = (state: RootState) => state.isEdit.isEdit;